export async function copyImageToClipboard(imageUrl: string): Promise<void> {
	const response = await fetch(imageUrl);
	const blob = await response.blob();
	await navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
}
